// XSM-1536 - SSO Feature
// Author: Abhishek Bharti
// Updated on 20/11/2025
// Description: This file contains the configuration for the application.
// It is used to store the configuration for the application.
export const APPLICATION_ENVIRONMENT = "dev";

export const PRODUCT_ORIGIN = process.env.REACT_APP_PRODUCT_URL as string;
// Frontend
export const XSM_FRONTEND_URL = process.env.REACT_APP_XSM_FRONTEND_URL as string;
export const XSI_FRONTEND_URL = process.env.REACT_APP_XSI_FRONTEND_URL as string;
// Backend
export const BACKEND_BASE_URL = process.env.REACT_APP_XSM_API_BASE_URL as string;

// Domains
export const COMMON_DOMAIN = process.env.REACT_APP_XSM_COMMON_DOMAIN as string;
export const MASTER_DOMAIN = process.env.REACT_APP_XSM_MASTER_DOMAIN as string;
export const PARTNER_DOMAIN = process.env.REACT_APP_XSM_PARTNER_DOMAIN as string;
export const EVES_SYS_DOMAIN = process.env.REACT_APP_XSM_SYSTEM_DOMAIN as string;

// Subdomains
export const COMMON_SUB_DOMAIN = process.env.REACT_APP_XSM_COMMON_SUB_DOMAIN as string;
export const MASTER_SUB_DOMAIN = process.env.REACT_APP_XSM_MASTER_SUB_DOMAIN as string;
export const PARTNER_SUB_DOMAIN = process.env.REACT_APP_XSM_PARTNER_SUB_DOMAIN as string;
export const EVES_SUB_SYS_DOMAIN = process.env.REACT_APP_XSM_SYSTEM_SUB_DOMAIN as string;
export const DEVICE_SUB_DOMAIN = process.env.REACT_APP_XSM_DEVICE_SUB_DOMAIN as string;

// Client IDS
export const COMMON_CLIENT_KEY = process.env.REACT_APP_XSM_COMMON_CLIENT_KEY as string;
export const MASTER_CLIENT_KEY = process.env.REACT_APP_MASTER_CLIENT_KEY as string;
export const PARTNER_CLIENT_KEY = process.env.REACT_APP_PARTNER_CLIENT_KEY as string;
export const SYS_ADMIN_CLIENT_KEY = process.env.REACT_APP_SYS_ADMIN_CLIENT_KEY as string;

// Client Secrets
export const COMMON_CLIENT_SECRET = process.env.REACT_APP_XSM_COMMON_CLIENT_SECRET as string;
export const MASTER_CLIENT_SECRET = process.env.REACT_APP_MASTER_CLIENT_SECRET as string;
export const PARTNER_CLIENT_SECRET = process.env.REACT_APP_PARTNER_CLIENT_SECRET as string;
export const SYS_ADMIN_CLIENT_SECRET = process.env.REACT_APP_SYS_ADMIN_CLIENT_SECRET as string;

// Callback URLs
export const COMMON_CALLBACK_URL = (process.env.REACT_APP_XSM_COMMON_CALLBACK_URL as string) || "";
export const MASTER_CALLBACK_URL = (process.env.REACT_APP_MASTER_CALLBACK_URL as string) || "";
export const PARTNER_CALLBACK_URL = (process.env.REACT_APP_PARTNER_CALLBACK_URL as string) || "";
export const SYS_ADMIN_CALLBACK_URL =
  (process.env.REACT_APP_SYS_ADMIN_CALLBACK_URL as string) || "";
export const DEVICE_MANAGER_CALLBACK_URL = (process.env.REACT_APP_DEVICE_MANAGER_CALLBACK_URL as string) || "";
